import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/iblShadowsCombine.fragment.js
var name, shader, iblShadowsCombinePixelShader;
var init_iblShadowsCombine_fragment = __esm({
  "node_modules/@babylonjs/core/Shaders/iblShadowsCombine.fragment.js"() {
    init_shaderStore();
    name = "iblShadowsCombinePixelShader";
    shader = `precision highp float;varying vec2 vUV;uniform sampler2D sceneTexture;uniform sampler2D textureSampler;uniform float shadowOpacity;void main(void)
{vec3 color=texture(sceneTexture,vUV).rgb;vec3 shadow=texture(textureSampler,vUV).rgb;float shadowValue=mix(1.0,shadow.x,shadowOpacity);gl_FragColor=vec4(color*shadowValue,1.0);}`;
    ShaderStore.ShadersStore[name] = shader;
    iblShadowsCombinePixelShader = { name, shader };
  }
});

export {
  iblShadowsCombinePixelShader,
  init_iblShadowsCombine_fragment
};
